import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ProjectdatasubsystemApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'projectdatasubsystem'
    }


    /**
     * 保存组织架构
     * @returns 
     */
    public updateRelation(param){
        return this.send(param,"updateRelation",Methods.POST)
    }
    
    /**
     * 组织机构子系统反选
     * @param subProjectId 
     * @returns 
     */
    public getCheckSubsystem(institutionRootId){
        return this.send({institutionRootId:institutionRootId},"getCheckSubsystem",Methods.GET)
    }


    /**
     * 分区项目id查询子系统列表
     * @param subProjectId 
     * @returns 
     */
    public getSystemList(subProjectId){
        return this.send({subProjectId:subProjectId},"getSystemList",Methods.GET)
    }

    /**
     * 查询组织机构（左侧treeview）
     * @param subProjectId 
     * @param subSystemId 
     */
    public getInstitutionList(subProjectId){
        return this.send({subProjectId:subProjectId},"getInstitutionList",Methods.GET)
    }

    /**
     * 过滤到同一子项目下不同组织机构选择同一子系统
     * @param institutionRootId 
     * @param subProjectId 
     */
    public checkPinless(institutionRootId,subProjectId){
        return this.send({institutionRootId:institutionRootId,subProjectId:subProjectId},"checkPinless",Methods.GET)
    }

   
}